import { prayerRamadanTr } from './golf4App.tr.js';
// Turks (tr-TR), weatherPrayer: zelfde vorm als weatherPrayer.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
//
// NEUTRAAL (zoals nl): locatie (behalve de varianten prayer/both) en het hele weer noemen nooit
// namaz, cami, ezan of dua. Gebedsnamen volgen de Diyanet-traditie (İmsak, Güneş, Öğle, İkindi,
// Akşam, Yatsı); "ezan okunur" is de gewone Turkse vorm. Weerwoorden gelijk aan kioskWeather.tr.ts.
export const weatherPrayerTr = {
    geo: {
        title: 'Konum',
        intro: 'Posta kodunu ya da yaşadığın yeri seç. Sadece yaklaşık bir kilometrelik bir bölgeyi saklarız.',
        searchLabel: 'Posta kodu ya da yer',
        searchPlaceholder: 'Örneğin 3511 AA ya da Utrecht',
        searchButton: 'Ara',
        searchHint: 'Ev numarası gerekmez; onu göndermiyoruz da.',
        noResults: 'Bir şey bulunamadı. Bir posta kodu ya da yer adı dene.',
        tooMany: 'Biraz yavaş: bir dakika sonra tekrar dene.',
        chosen: 'Bölge: {label}',
        privacy: 'Sokak, ev numarası ya da tam yer saklamayız. Bağlı akrabalar, misafirler ve takvim bağlantıları bunu asla görmez.',
        remove: 'Konumu sil',
        removed: 'Konum silindi.',
        variants: {
            weather: {
                settingsBody: 'Panodaki hava durumu için',
                why: 'Neden? Panodaki hava durumu için. Başka hiçbir şey için değil.',
                removeConfirm: 'Ailenin ve tabletlerin konumunu sileriz. Yeni bir konum seçene kadar hava durumu güncellenmez. Devam edilsin mi?',
                askBody: 'Bir kez, hava durumu için. Sadece yaklaşık bir kilometrelik bir bölgeyi saklarız.',
            },
            prayer: {
                settingsBody: 'Namaz vakitleri için',
                why: 'Neden? Namaz vakitleri için. Başka hiçbir şey için değil.',
                removeConfirm: 'Ailenin ve tabletlerin konumunu sileriz. Yeni bir konum seçene kadar namaz vakitleri güncellenmez. Devam edilsin mi?',
                askBody: 'Bir kez, panodaki saatler için. Sadece yaklaşık bir kilometrelik bir bölgeyi saklarız.',
            },
            both: {
                settingsBody: 'Hava durumu ve namaz vakitleri için',
                why: 'Neden? Panodaki hava durumu ve namaz vakitleri için. Başka hiçbir şey için değil.',
                removeConfirm: 'Ailenin ve tabletlerin konumunu sileriz. Yeni bir konum seçene kadar hava durumu ve namaz vakitleri güncellenmez. Devam edilsin mi?',
                askBody: 'Bir kez, panodaki hava durumu ve saatler için. Sadece yaklaşık bir kilometrelik bir bölgeyi saklarız.',
            },
        },
        device: {
            title: 'Bu tabletin konumu',
            household: 'Ailedeki gibi',
            own: 'Bu tabletin konumunu kullan',
            ownHint: 'Bu tablet başka bir yerdeyse kullanışlı, örneğin bir tatil evinde.',
            otherHome: 'Tablet başka birinin evinde mi? O zaman o evden de yaklaşık bir kilometrelik bir bölgeyi saklarız. Bunu o kişiye söyle.',
            pending: 'Tablette bir soru çıkar. Orada "Evet, bir kez belirle"ye dokun.',
            measured: 'Bu tabletin bölgesi: {label}',
            far: 'Bu tablet aile adresinden yaklaşık {km} km uzakta.',
            remeasure: 'Yeniden belirle',
            failed: 'Tablet konumunu belirleyemedi. Ailenin konumunu kullanıyoruz.',
        },
        kiosk: {
            askTitle: 'Bu tablet konumunu kullanabilir mi?',
            yes: 'Evet, bir kez belirle',
            no: 'Hayır',
            busy: 'Aranıyor…',
            done: 'Oldu: {label}',
            failed: 'Olmadı. Ailenin konumunu kullanıyoruz.',
        },
        web: {
            choose: 'Konum seç',
            change: 'Konumu değiştir',
            none: 'Henüz konum seçilmedi.',
            area: 'Bölge: {label}',
            tablets: 'Tabletler',
            tabletsNone: 'Henüz bağlı tablet yok.',
            edit: 'Değiştir',
            save: 'Kaydet',
            saved: 'Kaydedildi',
            cancel: 'Vazgeç',
            country: 'Ülke',
            countryNl: 'Hollanda',
            countryOther: 'Başka ülke',
            city: 'Yer',
            postcode: 'Posta kodu',
            countryCode: 'Ülke kodu (örn. BE ya da DE)',
            searching: 'Aranıyor…',
            pick: 'Bölgeni seç',
            removeTitle: 'Konum silinsin mi?',
            unavailable: 'Arama şu an çalışmıyor. Daha sonra tekrar dene.',
            requested: 'Ölçüm istendi',
            deviceSame: 'Ailedeki gibi',
            deviceSameWith: 'Ailedeki gibi ({label})',
        },
        credits: {
            pdok: 'Konum verileri: PDOK/Kadaster',
            osm: '© OpenStreetMap katkıcıları (ODbL)',
        },
    },
    weather: {
        title: 'Hava',
        settingsBody: 'Mont, çizme ya da güneş kremi? Çocukların evden çıktığı anlar için öneri',
        enabled: 'Hava durumunu göster',
        needsLocation: 'Önce bir konum seç, sonra hava durumunu gösterelim.',
        showInBanners: 'Çıkış uyarısında ("Saat 8:15 Okul zamanı: yağmurluk ve çizme")',
        adjust: 'Değiştir',
        morning: 'Sabah {start} ile {end} arası',
        thresholdsTitle: 'Hangi öneri ne zaman',
        thresholdsNote: 'Güneş, sıcak, rüzgâr ve buzlanma RIVM ve KNMI’ya göre. Mont ve kazak sınırları bizim varsayılanımız: istediğin gibi değiştir.',
        thresholds: {
            sweaterBelowC: 'Hissedilen {value} °C altında hırka ya da kazak',
            coatBelowC: '{value} °C altında mont',
            thickCoatBelowC: '{value} °C altında kalın mont',
            hatGlovesAtOrBelowC: 'Bere ve eldiven: {value} °C ve daha soğuk',
            umbrella: 'Yağmurda ve rüzgâr azken şemsiye öner',
            shortsFromC: '{value} °C ve üstünde, kuru havada şort olur',
            waterBottleFromC: '{value} °C ve üstünde su şişesi al',
        },
        perChild: 'Çocuk başına',
        coldDelta: {
            label: 'Çabuk üşür',
            value: { one: '{count} derece önce mont', other: '{count} derece önce mont' },
            warmer: { one: '{count} derece sonra mont', other: '{count} derece sonra mont' },
            none: 'Herkes gibi',
            hint: 'Bir çocuk çabuk mu üşüyor? Sayıyı artır: o kadar derece önce mont giymesi önerilir. Azaltırsan daha sonra.',
        },
        uvClearSky: 'UV indeksi {value} (açık havada)',
        uvCloud: 'UV indeksi {value}',
        feelsLike: 'Hissedilen {value} °C',
        wind: 'Rüzgâr {bft} bofor',
        stale: 'Hava şu an bilinmiyor',
        attribution: 'Hava verileri: MET Norway',
        feel: { cold: 'soğuk', chilly: 'serin', mild: 'güzel', warm: 'sıcak', hot: 'çok sıcak' },
        itemLabels: {
            warning: 'Dikkat',
            thunder: 'Gök gürültüsü',
            very_windy: 'Sert rüzgâr',
            slippery: 'Kaygan',
            very_cold: 'Çok soğuk',
            thick_coat: 'Kalın mont',
            coat: 'Mont',
            sweater: 'Kazak',
            raincoat: 'Yağmurluk',
            boots: 'Çizme',
            hat_gloves: 'Bere ve eldiven',
            no_umbrella: 'Kapüşonu tak',
            umbrella: 'Şemsiye',
            windy: 'Rüzgâr',
            shade: 'Güneşten uzak',
            sunscreen: 'Güneş kremi',
            sun_hat: 'Şapkanı tak',
            extra_drinks: 'Bol su iç',
            water_bottle: 'Su şişesi',
            midday_shade: 'Gölge',
            reapply: 'Yine krem sür',
            shorts: 'Şort',
        },
        itemWords: {
            warning: 'dikkat',
            thunder: 'gök gürlerse içeri gir',
            very_windy: 'çok sert rüzgâr: bisiklette sıkı tutun',
            slippery: 'kaygan olabilir: yavaş yürü, yavaş sür',
            very_cold: 'çok soğuk: dışarıda kısa kal',
            thick_coat: 'kalın mont',
            coat: 'mont',
            sweater: 'hırka ya da kazak',
            raincoat: 'yağmurluk',
            boots: 'çizme',
            hat_gloves: 'bere ve eldiven',
            no_umbrella: 'şemsiye yok, kapüşonu tak',
            umbrella: 'şemsiye',
            windy: 'sert rüzgâr: bisiklette dikkat',
            shade: 'güneşten uzak dur',
            sunscreen: 'güneş kremi sür',
            sun_hat: 'şapkanı tak',
            extra_drinks: 'bol su iç ve gölgede sakin oyna',
            water_bottle: 'su şişeni al',
            midday_shade: '12 ile 3 arası gölgede oyna',
            reapply: 'saat 12’de yine krem sür',
            shorts: 'şort giyebilirsin',
        },
        waterproof: 'kalın, su geçirmez mont',
        headline: {
            rain: 'Saat {time} yağmur var: {items}.',
            wet: 'Bu sabah ıslak olabilir: {items}.',
            wetLater: 'Saat {time} civarı ıslak olabilir: {items}.',
            snow: 'Saat {time} kar yağıyor: {items}.',
            thunder: 'Saat {time} gök gürültülü sağanak olabilir: gök gürlerse içeri gir.',
            cold: 'Saat {time} dışarısı soğuk: {items}.',
            hot: 'Hava ısınıyor: {items}.',
            coolThenWarm: 'Saat {time} serin, sonra sıcak: {items}.',
            sun: 'Güneşli: {items}.',
            wind: 'Saat {time} sert rüzgâr: bisiklette dikkat.',
            nice: 'Saat {time}: hava {feel}.',
            niceWith: 'Saat {time}: hava {feel}, {items}.',
            warning: '{kids}',
            departure: 'Saat {time} {title} zamanı: {items}.',
        },
        and: 've',
        warningKids: {
            wind: 'Rüzgâr çok sert esiyor. Montunu iyice kapat ve annenin ya da babanın yanında yürü.',
            rain: 'Çok yağmur yağıyor. Yağmurluğunu giy, çizmeni de al.',
            thunder: 'Gök gürültülü sağanak olabilir. Gök gürlerse içeri gireriz.',
            snow: 'Çok kar yağıyor. Çizmeni giy ve yavaş yürü.',
            ice: 'Dışarısı kaygan. Yavaş yürü, koşma.',
            heat: 'Hava çok sıcak. Bol su iç ve gölgede oyna.',
            cold: 'Hava çok soğuk. Sıkı giyin: bere ve eldiven.',
            fog: 'Hava sisli. Annenin ya da babanın yanında kal.',
            other: 'Bugün havaya biraz dikkat et.',
        },
        warningLevel: { yellow: 'Sarı kod', orange: 'Turuncu kod', red: 'Kırmızı kod' },
        web: {
            todayTitle: 'Bugün hava',
            todayTitleAt: 'Bugün hava · {label}',
            tomorrowTitle: 'Yarın hava',
            tomorrowTitleAt: 'Yarın hava · {label}',
            nowLabel: 'Şimdi',
            tomorrowLabel: 'Yarın',
            invite: 'Panoda hava önerisi ister misin?',
            inviteBody: 'Mont, çizme ya da güneş kremi: çocukların evden çıktığı anlarda söyleriz.',
            notNow: 'Şimdi değil',
            chooseLocation: 'Konum seç',
            settings: 'Ayarlar',
            showOnKiosk: 'Panoda',
            save: 'Kaydet',
            saved: 'Kaydedildi',
            resetDefaults: 'Varsayılana dön',
            morningStart: 'Sabah başlangıcı',
            morningEnd: 'Sabah bitişi',
            alsoFor: '{name}: {items}',
            everyone: 'Herkes',
            tempNow: '{temp}°',
            staleBody: 'Hava durumunu en kısa sürede yeniden alıyoruz.',
            childNone: 'Ailede henüz çocuk yok.',
            offTitle: 'Hava durumu kapatılsın mı?',
            offConfirm: 'Konumu başka hiçbir şey kullanmıyor. O zaman ailenin ve tabletlerin konumunu da sileriz. Devam edilsin mi?',
            offConfirmButton: 'Kapat ve konumu sil',
            offNotice: 'Hava durumu kapalı.',
            offNoLocation: 'Hava durumu kapalı. Bir konum seç; sonra hava durumunu buradan tek dokunuşla açarsın.',
            turnOn: 'Hava durumunu aç',
            less: 'Daha az',
            more: 'Daha fazla',
        },
        warningSource: {
            knmi: 'Kaynak: KNMI',
            meteoalarm: 'Kaynak: MeteoAlarm üzerinden KNMI',
            fake: 'Kaynak: test',
        },
        /** Yağış widget grafiğinin üstündeki cümle. */
        precip: {
            dryAll: 'Önümüzdeki {hours} saat kuru.',
            nowUntil: 'Şu an {kind}, {end} itibarıyla kuru.',
            nowLong: 'Önümüzdeki saatlerde {kind}.',
            fromUntil: '{start} itibarıyla {kind}, {end} itibarıyla kuru.',
            dryUntil: '{start} saatine kadar kuru, sonra {kind}.',
            words: {
                drizzle: 'çisenti',
                rain_light: 'hafif yağmur',
                rain: 'yağmur',
                rain_heavy: 'şiddetli yağmur',
                sleet: 'karla karışık yağmur',
                snow: 'kar',
                hail: 'dolu',
                thunder: 'gök gürültülü sağanak',
            },
        },
    },
    prayer: {
        // Golf 4: Ramadan op het bord (DESIGN §8.GB.14).
        ramadan: prayerRamadanTr,
        title: 'Namaz vakitleri',
        settingsBody: 'Bölgenin vakitleri, oturma odasındaki panoda',
        enabled: 'Namaz vakitlerini kullan',
        needsLocation: 'Önce bir konum seç. Sonra bölgenin vakitlerini hesaplarız.',
        privacy: 'Bu, "Ailemize uygun olanlar" bölümüne aittir. Ayarları sadece siz ebeveynler görürsünüz; bağlı akrabalar ve misafirler asla görmez.',
        boardVisible: 'Dikkat: vakitler ve kart panoda durur, yani odadaki herkes onları görür (misafir ya da bakıcı da).',
        call: { turkish: 'ezan', arabic: 'adhan' },
        callTitle: { turkish: 'Ezan', arabic: 'Adhan' },
        setup: {
            quickTitle: 'Namaz vakitleri',
            quickBody: '{method} ile hesaplıyoruz. Camine uyuyor mu? O zaman tamam. Vakitleri ayarlamak ve her namaz için sesi seçmek her zaman mümkün.',
            quickNoCall: 'Henüz {call} kaydı yok. Sen bir kayıt yükleyene kadar oturma odasındaki tablette yumuşak bir zil sesi çalar.',
            quickTone: '"Hangi kayıt?" bölümünde şu an yumuşak zil sesi seçili. {call} sesini duymak ister misin? "Daha fazla ayar" ile oradan hazır kaydı seç.',
            quickTimes: 'Bugün {place}',
            quickDone: 'Tamam',
            quickMore: 'Daha fazla ayar',
            step1: 'Vakitleri nasıl hesaplıyoruz?',
            step1Body: 'Camilerin hepsi aynı şekilde hesaplamaz. Caminin kullandığını seç ya da bizim seçimimizi bırak.',
            step2: 'Kendi camine göre ayarla',
            step2Body: 'Caminin takvimini yanına koy. Bir vakit farklıysa kaydır. Yazın camiler bazen yarım saat ya da daha fazla farklı olur: o zaman ay ay ayarla ya da yıllık takvimi yükle.',
            step3: 'Tablette ne çalsın?',
            step3Body: '{call} oturma odasındaki tablette okunur. Diğer tabletler sen açmadıkça sessiz kalır.',
            step3BodyNoCall: 'Henüz {call} kaydı yok. Aşağıdan sen bir kayıt yükleyene kadar "{callTitle}" seçeneğinde yumuşak zil sesi çalar. Diğer tabletler sen açmadıkça sessiz kalır.',
            step3BodyTone: '"{callTitle}" seçeneğinde şu an yumuşak zil sesi çalar, çünkü "{step4}" bölümünde o seçili. Diğer tabletler sen açmadıkça sessiz kalır.',
            step4: 'Hangi kayıt?',
            done: 'Tamam. Sıradaki namaz vakti artık panoda.',
        },
        method: {
            diyanet: 'Diyanet (Türkiye)',
            mwl: 'Dünya İslam Birliği (MWL)',
            uoif: 'UOIF (Fransa)',
            morocco: 'Fas',
            jafari: 'Caferi (Şii)',
            eu_joint: 'Avrupa ortak takvimi (Diyanet · Milli Görüş)',
        },
        methodInSentence: {
            diyanet: 'Diyanet takvimi (Türkiye)',
            mwl: 'Dünya İslam Birliği (MWL)',
            uoif: 'UOIF (Fransa)',
            morocco: 'Fas yöntemi',
            jafari: 'Caferi yöntemi (Şii)',
            eu_joint: 'Avrupa ortak takvimi (Diyanet · Milli Görüş)',
        },
        methodHint: {
            diyanet: 'Türkiye takvimi. Avrupa’daki Türk camileri yukarıdaki Avrupa takvimini kullanır.',
            mwl: 'Avrupa’da yaygın. Emin değilsen iyi bir varsayılan.',
            uoif: 'İmsak daha geç, yatsı daha erken (12°).',
            morocco: 'Fas kökenli camilerin sık kullandığı yöntem.',
            jafari: 'Akşam namazı alacakaranlıktan sonra, gün batımından yaklaşık çeyrek saat sonra.',
            eu_joint: '2023’ten beri Avrupa’da Diyanet (ISN, DITIB) ve Milli Görüş için aynı takvim. Camiiniz Türk camisiyse bunu seçin.',
        },
        asrSchool: {
            standard: 'Standart (ilk vakit)',
            hanafi: 'Hanefi (öğleden sonra daha geç)',
        },
        asrSource: {
            title: '{asr} vakti',
            madhab: 'Mezhebinize göre',
            manual: 'Kendiniz ayarladınız',
            unset: 'Varsayılan',
            follow: 'Yine mezhebe göre olsun',
            madhabLink: 'Mezhebi seç veya değiştir',
            why: {
                hanafi: 'Hanefi mezhebini takip ediyorsunuz: {asr} öğleden sonra daha geç.',
                other_madhab: '{madhab} mezhebini takip ediyorsunuz: {asr} standart vakitte.',
                calendar: 'Hanefi mezhebini takip ediyorsunuz. Diyanet ve Milli Görüş takvimi {asr} için ilk vakti (asr-ı evvel) verir, caminiz gibi. Daha geç vakti (asr-ı sani) mi istiyorsunuz? Yukarıdan "{hanafi}" seçeneğini seçin.',
                no_madhab: 'Henüz mezhep seçilmedi: {asr} standart vakitte.',
            },
            manualWhy: 'Bunu kendiniz seçtiniz. Başka bir mezhep bunu değiştirmez.',
        },
        madhabSuggestion: {
            body: 'Hanefi mezhebini takip ediyorsunuz. Avrupa’daki Türk camileri {method} ile hesaplar.',
            apply: 'Bu takvimi kullan',
            applied: 'Artık {method} ile hesaplıyoruz.',
        },
        naming: { turkish: 'Türkçe adlar', arabic: 'Arapça adlar' },
        namingTitle: 'Namaz vakitlerinin adları',
        names: {
            turkish: {
                fajr: 'Sabah',
                sunrise: 'Güneş',
                dhuhr: 'Öğle',
                asr: 'İkindi',
                maghrib: 'Akşam',
                isha: 'Yatsı',
            },
            arabic: {
                fajr: 'Fajr',
                sunrise: 'Gün doğumu',
                dhuhr: 'Dhuhr',
                asr: 'Asr',
                maghrib: 'Maghrib',
                isha: 'Isha',
            },
        },
        cardNames: {
            turkish: { fajr: 'Sabah', dhuhr: 'Öğle', asr: 'İkindi', maghrib: 'Akşam', isha: 'Yatsı' },
            arabic: { fajr: 'Fajr', dhuhr: 'Dhuhr', asr: 'Asr', maghrib: 'Maghrib', isha: 'Isha' },
        },
        sunriseNote: '{fajr} vakti gün doğumunda biter. O anda hiçbir ses çalmaz.',
        offsets: {
            title: 'Namaz başına fark',
            sameAllYear: 'Bütün yıl aynı',
            perMonth: 'Ay ay',
            month: 'Ay: {month}',
            later: '{value} dk sonra',
            earlier: '{value} dk önce',
            seeded: 'Rotterdam Diyanet takvimine göre ayarlandı, sadece eylül için kontrol edildi. Kendi caminle karşılaştır, özellikle yazın.',
            tableDay: 'Bu vakitler caminin takviminden geliyor. Farklar sadece takvimde olmayan günler için geçerli.',
            compare: 'Caminin takvimiyle karşılaştır',
            dstCheck: 'Saatler değişti. Caminin takvimiyle hâlâ uyuyor mu?',
            dstYes: 'Evet, uyuyor',
            dstAdjust: 'Değiştir',
        },
        table: {
            title: 'Caminin takvimini yükle',
            body: 'Yıllık takvimi yapıştır (her satırda: tarih; {fajr}; gün doğumu; {dhuhr}; {asr}; {maghrib}; {isha}). Takvimdeki bir gün bizim hesabımızın yerini alır.',
            read: 'Yükle',
            result: { one: '{count} gün yüklendi', other: '{count} gün yüklendi' },
            badLines: 'Okunamadı: satır {lines}',
            fromTable: 'Caminin takviminden',
            remove: 'Takvimi kaldır',
        },
        sound: {
            adhan: '{callTitle}',
            adhanPending: '{callTitle} (henüz kayıt yok: şimdilik zil sesi)',
            adhanTone: '{callTitle} (şimdilik zil sesi, bkz. "{step4}")',
            chime: 'Yumuşak zil sesi',
            silent: 'Sessiz (sadece kart)',
        },
        yearRange: '{name}: {month} ayında saat {time} civarı',
        fajrWarning: '{fajr} gün doğumundan önce. O saatte okunan {call} bütün evi uyandırır.',
        fajrNeedsRecording: '{fajr} için ayrı bir okunuş vardır ("es-salâtü hayrun mine’n-nevm" ile), bu yüzden orada normal okunuş hiç çalmaz. {fajr} için kendi kaydını yükle ya da zil sesini seç.',
        quiet: {
            title: 'Akşamdan sonra ve gece',
            body: '{from} ile {until} arasında {call} yerine şu çalar:',
            chime: 'yumuşak bir zil sesi',
            silent: 'hiçbir şey (sadece oturma odasındaki kart)',
            adhan: 'yine de {call}',
            hint: 'Haziranda {isha} gece yarısına, {maghrib} saat ondan sonraya düşer. Zil sesiyle ev sakin kalır.',
        },
        /** Eenmalige melding na het overzetten naar de gezamenlijke kalender (0041). */
        methodNotice: 'Namaz vakitleri artık Diyanet ve Milli Görüş’ün Avrupa takvimine göre; bu yüzden yazın {fajr} ve {isha} vakitleri farklı.',
        methodNoticeOk: 'Tamam',
        /** Eerlijk over eu_joint (gefit op de Diyanet-tabellen, niet officieel; review g6b fs r1). */
        methodApprox: 'Ortak takvimi kendimiz hesaplıyoruz. Rotterdam ve Amsterdam için yıl boyunca tablodan en fazla 1-2 dakika farklı. Hiçbir vakit ve tabletteki hiçbir ezan Diyanet tablosundan erken değil: yukarı yuvarlıyoruz, {fajr} için de 2 dakika, nisan ortasından eylül ortasına kadar 10 dakika ekliyoruz. Orucun başladığı imsak ise hiçbir zaman tablodan geç değil; Ramazan’da panoda hem imsak hem {fajr} görünür. Başka yerlerde, özellikle nisan ortasından eylül ortasına kadar, caminiz birkaç dakika (yaklaşık 9 dakikaya kadar) farklı olabilir. Camiinize göre ayarlayın; örneğin Namaz başına fark altında {fajr} için birkaç dakika ekleyin ya da caminizin takvimini yükleyin.',
        /** Korte zin bij de tijden (Vandaag, tablet) in de zomerweken van eu_joint. */
        methodTune: 'Yaz vakitleri: caminiz birkaç dakika farklı olabilir. Camiinize göre ayarlayın.',
        /** Opnamebibliotheek (golf 6b, DESIGN §8.GB.15). */
        library: {
            intro: 'Bölgeye göre bir kayıt seçin. Önce dinleyin: bunlar gerçek kayıtlar, bazen şehir sesi veya kuş sesi var.',
            regions: {
                arabic: 'Arap tarzı',
                hijaz: 'Mekke (Hicaz)',
                turkish: 'İstanbul ve Türkiye',
                maghreb: 'Fas',
                egypt: 'Mısır',
                levant: 'Ürdün',
                southeast_asia: 'Malezya',
                central_asia: 'Kazakistan',
                europe: 'Avrupa',
                other: 'Diğer (yeri bilinmiyor)',
            },
            places: {
                mecca: 'Mekke, Mescid-i Haram',
                istanbul: 'İstanbul (kısa)',
                istanbul_fatih: 'İstanbul, Kalenderhane Camii',
                mardin: 'Mardin, sabah',
                patara: 'Patara, köy, sabah',
                casablanca: 'Kazablanka, II. Hasan Camii',
                marrakech: 'Marakeş, Cemaa el-Fna',
                marrakech_medina: 'Marakeş, medine, sabah',
                quseir: 'El Kuseyr, deniz kenarı',
                amman: 'Amman, sabah',
                kuala_lumpur: 'Kuala Lumpur, sabah',
                shalqar: 'Şalkar',
                malmo: 'Malmö, sabah',
                indoor: 'Cuma, içeride kaydedildi',
            },
            option: '{place} ({year})',
            meta: '{author} · {license} · {duration}',
            fajrTitle: '{fajr} için kayıt',
            fajrBody: '{fajr} vaktinin kendine ait bir ezanı var, "es-salâtu hayrun mine’n-nevm" ile. Bir sabah kaydı seçin veya kendi kaydınızı yükleyin; yoksa {fajr} vaktinde zil çalar.',
            fajrNone: 'Yok (zil)',
            fajrUnverified: 'sabah kaydı, sabah cümlesi henüz kontrol edilmedi',
            sources: 'Kaynaklar ve lisanslar',
            sourcesIntro: 'Tüm kayıtlar serbestçe kullanılabilir. Her kayıt için başlık, kaydı yapan, kaynak ve lisans burada. Başındaki ve sonundaki sessizliği kestik, ses seviyelerini eşitledik ve AAC’ye çevirdik.',
            by: '"{title}", {author}, {platform} üzerinden',
            shareAlike: 'Düzenlediğimiz sürüm de {license} lisansı altındadır.',
            report: 'Bir kaynak yanlış mı? support@amumin.com adresine yazın, kaydı kaldıralım.',
        },
        audio: {
            builtin_a: '{callTitle}, Arap tarzı',
            builtin_b: '{callTitle}, Arap tarzı (daha kısa)',
            sunniNote: 'Bu kayıtlarda Sünni metin okunur.',
            shiaNote: 'Kayıtlarımızda Sünni metin okunur. Zil sesini ya da kendi kaydını seç.',
            tone: 'Yumuşak zil sesi (görev zillerinden farklı, kendine özgü bir ses)',
            own: 'Kendi kaydını yükle (m4a ya da mp3, en fazla 5 dakika)',
            ownFajr: '{fajr} için kendi kaydın',
            credits: 'Kayıtlar hakkında',
        },
        kidsMayStop: 'Çocuklar {call} sesini durdurabilir',
        kidsMayStopHint: 'Kapalıysa: Durdur düğmesi ebeveyn kontrollerinde.',
        device: {
            title: 'Hangi tabletlerde?',
            sound: '{callTitle} okunsun',
            soundAny: 'Namaz vaktinde ses',
            line: 'Başlıkta sıradaki namaz',
            card: 'Namaz vaktinde kart',
            cardNight: 'Bir odada gece asla kart çıkmaz.',
            volume: 'Ses düzeyi',
            volumeIos: 'iPad’de sesi yandaki düğmelerle ayarlarsın.',
            test: 'Tablette dene',
            locked: '{name}: ses kapalı. O tabletin ekranına bir kez dokun.',
            unsupported: '{name}: bu tablet ses çalamıyor.',
            outcome: {
                played: 'Saat {time} çaldı',
                card_locked: 'Saat {time} sessiz: ses kapalıydı',
                card_late: 'Saat {time} sessiz: geç görüldü',
                load_failed: 'Saat {time} sessiz: kayıt yüklenemedi',
                skipped: 'Saat {time} atlandı',
            },
            checklist: 'Ekranı açık bırak (Otomatik Kilit: Hiçbir Zaman). Rehberli Erişim’de: açma/kapama düğmesi kapalı, ses düğmeleri açık. iPad’i açma/kapama düğmesiyle uyutma: yoksa {isha} ve {fajr} sessiz kalır.',
        },
        kiosk: {
            next: '{name} {time}',
            nextIn: '{name} {time} · {left} sonra',
            inMinutes: '{n} dk sonra',
            inHours: '{n} sa sonra',
            now: 'Şimdi: {name}',
            cardTitle: '{name} namazı vakti',
            playing: '{callTitle} okunuyor',
            playingChime: 'Zil çalıyor',
            cardStop: 'Durdur',
            cardStopHold: 'Durdurmak için basılı tut',
            cardClose: 'Kapat',
            soundLocked: 'Ses için dokun',
            soundLockedLong: 'Ses kapalı. Açmak için dokun.',
            unsupported: 'Bu tablet ses çalamıyor',
            unknown: 'Namaz vakitleri şu an bilinmiyor',
        },
        question: {
            title: 'Namaz vakitleri panoda olsun mu?',
            body: 'O zaman sıradaki namaz panonun en üstünde görünür ve namaz vakitlerinde oturma odasındaki tablette {call} okunur.',
            body2: '{fajr} varsayılan olarak sessizdir. Her şeyi sonra değiştirebilirsin.',
            yes: 'Evet, lütfen',
            no: 'Hayır, şimdi değil',
            declined: 'Daha sonra Ayarlar > Namaz vakitleri bölümünden açabilirsin.',
            placeTitle: 'Nerede oturuyorsunuz?',
            placeBody: 'O zaman bölgenin vakitlerini hesaplarız. Bir posta kodu ya da yer adı yeterli; sadece yaklaşık bir kilometrelik bir bölgeyi saklarız.',
            placeOther: 'Hollanda dışında mı, ya da tablet başka bir yerde mi? Bunu Ayarlar > Konum bölümünden ayarlarsın.',
            placeSave: 'Bu yeri kullan',
            placeChosen: 'Vakitler: {label}',
            /** Golf 6c: waarom deze methode (de mazhab, nooit de keuken). */
            methodMadhab: '{method} ile hesaplıyoruz, çünkü Hanefi mezhebini takip ediyorsunuz.',
            methodDefault: '{method} ile hesaplıyoruz.',
            change: 'Değiştir',
            methodChoose: 'Hesaplama yöntemi',
            becauseOne: 'Çünkü {name} için İslam seçildi.',
            becauseMany: 'Çünkü {names} için İslam seçildi.',
            next: 'Devam',
            done: 'Tamam',
            enabled: 'Sıradaki namaz artık panoda.',
            renew: 'İzin ver ve aç',
            off: 'Namaz vakitleri kapalı. Pano onları göstermez ve hiçbir ses çalmaz.',
            turnOn: 'Namaz vakitlerini aç',
            offBody: 'Bir süre olmadan mı? O zaman vakitler panodan kalkar ve hiçbir ses çalmaz. Yöntem ve ses seçimlerin saklanır; hava durumu da kapalıysa konumu sileriz.',
            turnOff: 'Namaz vakitlerini kapat',
            turnOffConfirm: 'Namaz vakitleri kapatılsın mı? Buradan her zaman yeniden açabilirsin.',
            turnOffYes: 'Evet, kapat',
            turnOffCancel: 'Vazgeç',
            renewOnly: 'İzin ver',
            renewBody: '"Ailemize uygun olanlar" açıklaması değişti: artık bu namaz vakitleri gibi panodaki ek bölümlerden de söz ediyor. Onları kullanmaya devam etmek için burada yeniden izin ver.',
        },
        web: {
            consentRenewal: '"Ailemize uygun olanlar" açıklaması değişti: artık bu namaz vakitleri gibi panodaki ek bölümlerden de söz ediyor. Önce orada yeniden izin ver.',
            consentLink: 'Ailemize uygun olanlar bölümüne git',
            locationLink: 'Konum seç',
            save: 'Kaydet',
            saved: 'Kaydedildi',
            today: 'Bugün, {place}',
            ourTime: 'hesaplanan',
            offset: 'fark',
            month: 'Ay',
            tableDays: {
                one: 'Caminin takviminden {count} gün',
                other: 'Caminin takviminden {count} gün',
            },
            tablePlaceholder: '2026-10-01;05:40;07:30;13:35;16:45;19:15;20:50',
            listen: 'Dinle',
            /** Tijdens het afspelen (review g6b ux r1: een stopknop, geen luidspreker met streep). */
            listenStop: 'Durdur',
            listenPlaying: 'Çalıyor',
            upload: 'Dosya seç',
            uploaded: 'Kendi kaydın kullanılıyor',
            uploadFailed: 'Sadece en fazla 5 dakika ve 5 MB olan bir m4a ya da mp3 dosyası.',
            last: 'Son: {items}',
            testPending: 'Deneme gönderildi. Sonuç bir dakika içinde burada görünür.',
            uploadCall: 'Kendi {call} kaydını yükle',
            testResult: {
                played: 'Çaldı',
                card_locked: 'Sessiz: ses kapalıydı',
                load_failed: 'Sessiz: kayıt yüklenemedi',
                skipped: 'Atlandı',
            },
            volume: 'Ses düzeyi (Android, Fully Kiosk)',
            noTablets: 'Henüz bağlı tablet yok.',
            credits: {
                builtin: '{callTitle}, Arap tarzı: {author} tarafından "{title}", kaynak:',
                license: 'CC0 1.0 (kamu malı)',
                processing: 'Kaydı AAC ve MP3’e (mono) dönüştürdük ve zil sesiyle aynı yükseklikte yaptık. Bunun dışında hiçbir şey değiştirilmedi.',
                tone: 'Yumuşak zil sesi AMUMIN’e ait özgün bir sestir.',
            },
        },
        attribution: 'Namaz vakitleri: kendi hesabımız · yöntem {method}',
        attributionTable: 'Namaz vakitleri: caminin takvimi',
        hijri: {
            months: [
                'Muharrem',
                'Safer',
                'Rebiülevvel',
                'Rebiülahir',
                'Cemaziyelevvel',
                'Cemaziyelahir',
                'Recep',
                'Şaban',
                'Ramazan',
                'Şevval',
                'Zilkade',
                'Zilhicce',
            ],
            pattern: '{day} {month} {year} H.',
        },
    },
};
//# sourceMappingURL=weatherPrayer.tr.js.map